<template>
  <el-form :model="formData" label-width="10px" style="height: 40px">
    <el-row>
<!--      <el-form-item label="" prop="star">-->
<!--        <el-select v-model="formData.wujianId" @change="getBuildingNameList" filterable placeholder="物件番号"-->
<!--                   class="toolbar_item" style="width: 200px" clearable>-->
<!--          <el-option v-for="dict in wujianNameList" :key="dict.value" :label="dict.label"-->
<!--                     :value="dict.value"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item>-->
<!--        <el-select v-model="formData.building" placeholder="楼层" class="toolbar_item" style="width: 70px" clearable>-->
<!--          <el-option v-for="dict in buildingNameList" :key="dict.floor" :label="dict.floor"-->
<!--                     :value="dict.floor"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item>-->
<!--        <el-button type="primary" :loading="wujianVisualizationBool" @click="getWujianVisualization">查询-->
<!--        </el-button>-->
<!--      </el-form-item>-->

      <el-form-item>
        <i class="dotClass" style="background: #E9ECEF"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.noZk') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #a0d7ff"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.zking') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #37e3dc;"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.zkEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #1436e8bf"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.sczsEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #FFD43B;"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.jgEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #ea29e6"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.tzEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #94D82D"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.zzEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #12B886"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.chEnd') }}</span>
      </el-form-item>
    </el-row>
  </el-form>

  <div id="tableContainer">
  <el-table style="overflow: auto;padding: 0" :data="wujianVisualization" border :height="tableHeight"
            :header-cell-style="{textAlign: 'center'}"
            :cell-style="{ textAlign: 'center'}"
            size="small">
    <el-table-column prop="floor" label="楼面" width="60" fixed/>
    <el-table-column v-for="facade in facadeList" :min-width="flexColumnWidth(facade.facade_id,facade.facade_id)"
                     :prop="facade.facade_id" :key="facade.facade_id" :label="facade.facade_id">
      <template v-slot="scope">
        <div style="display: flex;flex-direction: row">
          <div style="background-color: #D0EBFF;margin-left: 2px;width: 4px;height: 100%;" :style="unit.color"
               v-for="(unit,index) in scope.row[facade.facade_id]" :key="index">
            <el-tooltip class="box-item" effect="dark" :content="unit.unit_no" placement="top">
              <span>&nbsp;</span>
            </el-tooltip>
          </div>
          <!--            <div v-if="scope.row[facade.facade_id].length > 0" style="">-->
          <!--              &nbsp;{{scope.row[facade.facade_id].length}}-->
          <!--            </div>-->
        </div>
      </template>
    </el-table-column>
  </el-table>
  </div>

</template>

<script>
export default {
  name: "MfgZLVisualization",
  props: ['parentData'],
  components:{},
  data() {
    return {
      formData: {
        wujianId:'',
      },
      wujianNameList:[],
      buildingNameList:[],
      wujianVisualization:[],
      newUnitList:[],
      facadeList:[],
      wujianVisualizationBool: false,
      tableHeight: window.innerHeight - 170,
      scrollDirection: 'down',  // 滚动方向，初始为向上
      scrollInterval: null,  // 滚动定时器

    }
  },methods: {
    getWujianVisualizationAll() {
      this.wujianVisualizationBool = true;
      let params = {wujianId: this.formData.wujianId, buildingNameList: this.buildingNameList}
      this.$axios.post('mfg/visualization/getWujianVisualizationAll', params).then(response => {
        this.wujianVisualizationBool = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.wujianVisualization = res.data.newUnitList;
        this.facadeList = res.data.facadeList;
        // sessionStorage.setItem("wujianVisualization",JSON.stringify(this.wujianVisualization))
        // sessionStorage.setItem("facadeList",JSON.stringify(this.facadeList))
        this.startScrolling();
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    flexColumnWidth (label, prop) {
      // 1.获取该列的所有数据
      const arr = this.wujianVisualization.map(x => x[prop])
      arr.push(label) // 把每列的表头也加进去算
     // console.log(arr)
      let maxCnt = 0 ;
      for (let cnt of arr) {
        if (maxCnt < cnt.length) {
          maxCnt = cnt.length;
        }
      }
      return maxCnt * 6 + 24;
    },
    startScrolling() {

      let tableContainer = document.getElementById('tableContainer').getElementsByClassName('el-scrollbar__wrap')[0];

      setTimeout(() => {
        tableContainer.scrollTop = tableContainer.scrollHeight;

        this.scrollInterval = setInterval(() => {

          let scrollTop = tableContainer.scrollTop;
          let scrollHeight = tableContainer.scrollHeight;
          let clientHeight = tableContainer.clientHeight;

          if (this.scrollDirection === 'up') {
            // 向上滚动
            tableContainer.scrollTop += 1;
            if (scrollTop + clientHeight >= scrollHeight) {
              // 到达底部，切换为向下滚动
              this.scrollDirection = 'down';
            }
          } else {
            // 向下滚动
            tableContainer.scrollTop -= 1;
            if (scrollTop <= 0) {
              // 到达顶部，切换为向上滚动
              this.scrollDirection = 'up';
            }
          }
        }, 50);// 每 100 毫秒滚动一次
      },50)  // 延迟 100 毫秒执行滚动操作
    },
    stopScrolling() {
      clearInterval(this.scrollInterval);
    }
  },created() {
    this.formData.wujianId = this.parentData
    this.getWujianVisualizationAll()
    //缓存
    // if (sessionStorage.getItem("wujianVisualization") == null){
    //   this.getWujianVisualizationAll()
    // }else {
    //   this.wujianVisualization = JSON.parse(sessionStorage.getItem("wujianVisualization"))
    //   this.facadeList = JSON.parse(sessionStorage.getItem("facadeList"))
    // }
  },
  mounted() {
    // window.onresize:浏览器尺寸变化响应事件
    window.onresize = () => {
      return (() => {
        // window.innerHeight:浏览器的可用高度
        window.screenHeight = window.innerHeight;
        this.tableHeight = window.screenHeight - 170;
      })();
    };
  },
  unmounted() {
    this.stopScrolling();
  }
}

</script>
<style scoped>
.dotClass {
  height: 15px;
  width: 15px;
  margin-left: 10px;
}
div /deep/ .el-table tbody tr:hover>td {
  background: #ffffff!important
}

.table :deep(.el-table__cell) {
  padding: 0 0;
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
  z-index: 1;
}

.table :deep(.el-table-fixed-column--left){
  z-index: 2;
}

</style>